import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { CustomersModel } from '../models/customers-model';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {

  constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
      }
      public getPatient(patientCode: string , comCode: string) {
        let params = new HttpParams();
          params = params.append("patientCode", patientCode);
          params = params.append("compCode", comCode);
          const options = {
              params: params
          };
          return this.http.get<CustomersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Customers/GetCustomers',options);
      }
      public getNextSerial(yearEntry: string , comCode: string) {
        let params = new HttpParams();
          console.log("serv.yearEntry", yearEntry)
          params = params.append("cuurentyear", yearEntry);
          params = params.append("compCode", comCode);
          const options = {
              params: params
          };
          return this.http.get<CustomersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Customers/PatSerial',options);
      }
      public AddPatient(PatientData: CustomersModel) {

          return this.http.post<CustomersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Customers/AddCustomers', PatientData);
      }
      public UpdatePatient(PatientData: CustomersModel) {

        return this.http.post<CustomersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Customers/UpdateCustomers', PatientData);
    }
      public UpdatePatientReferd(patientCode: string , referedfrom: string, compCode: string) {
       debugger;
         let params = new HttpParams();
          params = params.append("patientCode", patientCode);
          params = params.append("referredfrom", referedfrom);
          params = params.append("cmpCode", compCode);
          const options = {
            params: params
        };
        return this.http.get<CustomersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Customers/UpdateReferdCustomers', options);
    }
      public delPatient(patientCode: string , compCode: string) {

        let params = new HttpParams();
          params = params.append("patientCode", patientCode);
          params = params.append("compCode", compCode);
          const options = {
            params: params
        };
        return this.http.get<CustomersModel>(this.urlsconfig.WebAPIURL_Test + 'api/Customers/DeleteCustomers',options);
      }

      public getPatientLookup(patientCode: string, PatientFName: string,telMobile:string,telHome:string,telBusin:string, cancerID:string , compCode: string) {
        let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("PatientFName", PatientFName);
        params = params.append("telMobile", telMobile);
        params = params.append("telHome", telHome);
        params = params.append("telBusin", telBusin);
        params = params.append("cancerId", cancerID);

        params = params.append("compCode", compCode);
        const options = {
            params: params
        };
        return this.http.get<CustomersModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Customers/CustomersLookup', options);
    }

      public GetCustomersTop(compCode: string) {
        let params = new HttpParams();
        params = params.append("compCode", compCode);
        const options = {
            params: params
        };
        return this.http.get<CustomersModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Customers/CustomersLookupTop', options);
    }
  }
